<template>
    <div v-if="isLoaded">
        <div class="content-body">
            <b-modal id="modal_form"
                     ref="modal_form"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form.errors.any()
                     v-model="showModal"
                     @ok="handleOk">
                <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                    <label>Nome do Município</label>
                    <b-form-input type="text"
                                  placeholder="Nome do Município"
                                  v-model="form.nome"
                                  name="nome"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('nome')" v-if="form.errors.has('nome')"></b-form-feedback>

                    <label>Código IBGE</label>
                    <b-form-input type="text"
                                  placeholder="Código IBGE"
                                  v-model="form.cd_ibge"
                                  name="cd_ibge"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('cd_ibge')" v-if="form.errors.has('cd_ibge')"></b-form-feedback>

                    <label>Código ERP</label>
                    <b-form-input type="text"
                                  placeholder="Código ERP"
                                  v-model="form.cd_opentech"
                                  name="cd_opentech"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('cd_opentech')" v-if="form.errors.has('cd_opentech')"></b-form-feedback>


                    <label>UF</label>
                    <multiselect v-model="ufSelected"
                    :options="optionsListItemUf"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Pressione enter para selecionar"
                    select-label="Pressione enter para selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('uf')" v-if="form.errors.has('uf')"></b-form-feedback>

                    <label>Status</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.status"
                        :options="optionsLivStatus"
                        name="status"
                        stacked
                        plain
                      ></b-form-radio-group>
                    </b-form-group>
                    <b-form-feedback v-text="form.errors.get('status')"  v-if="form.errors.has('status')"></b-form-feedback>

           </form>
                  <div slot="modal-footer" class="w-100">
                         <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                         <div class="float-right">
                             <b-btn @click="showModal=false" variant="secondary">
                               Fechar
                             </b-btn>
                             <b-btn @click="handleOk($event)" variant="primary" :disabled="isDisabled">
                               Enviar
                             </b-btn>
                         </div>
                  </div>
              </b-modal>
              <b-modal id="modal_form_cep"
                       ref="modal_form_cep"
                       :title="modal_titulo"
                       :ok-title="modal_botao"
                       close-title="Fechar"
                       cancel-title="Cancelar"
                       :ok-disabled=form_cep.errors.any()
                       v-model="showModalCep"
                       @ok="handleOkCep">
                  <form @submit.stop.prevent="handleOkCep" @keydown="form.errors.clear($event.target.name)">
                      <label>CEP Inicial</label>
                      <b-form-input type="text"
                                    placeholder="Cep"
                                    v-model="form_cep.cep_inicial"
                                    name="cep_inicial"
                                    >
                      </b-form-input>
                      <b-form-feedback class="text-danger" v-text="form_cep.errors.get('cep_inicial')" v-if="form_cep.errors.has('cep_inicial')"></b-form-feedback>

                      <label>CEP Final</label>
                      <b-form-input type="text"
                                    placeholder="Cep"
                                    v-model="form_cep.cep_final"
                                    name="cep_final"
                                    >
                      </b-form-input>
                      <b-form-feedback class="text-danger" v-text="form_cep.errors.get('cep_final')" v-if="form_cep.errors.has('cep_final')"></b-form-feedback>

                      <div v-if="this.modal_acao=='u'">
                          <label>Status</label>
                          <b-form-group>
                            <b-form-radio-group
                              v-model="form_cep.status"
                              :options="optionsLivStatusCep"
                              name="status"
                              stacked
                              plain
                            ></b-form-radio-group>
                          </b-form-group>
                          <b-form-feedback v-text="form_cep.errors.get('status')"  v-if="form_cep.errors.has('status')"></b-form-feedback>
                      </div>

             </form>
                    <div slot="modal-footer" class="w-100">
                           <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                           <div class="float-right">
                               <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                               <b-btn @click="showModalCep=false" variant="secondary">
                                 Fechar
                               </b-btn>
                               <b-btn @click="handleOkCep($event)" variant="secondary" :disabled="isDisabled">
                                 Enviar
                               </b-btn>
                           </div>
                    </div>
                </b-modal>
        </div>
    </div>
</template>
<script>
import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
    dataExport: [],
    modal_titulo: '',
    modal_botao: '',
    modal_acao: '',
    loading: false,
    isDisabled: false,
    loadingData: true,
    showModal: false,
    showModalCep: false,
    isFullscreen: false,
    ufSelected: [],
    optionsLivStatus: [],
    optionsLivStatusCep: [],
    optionsListItemUf: [],
    errors_array: [],
    form: new Form({
              nome: '',
              cd_ibge: '',
              cd_opentech: '',
              municipio_id: '',
              uf_id: '',
              status: ''}),
   form_cep: new Form({cep_inicial: '', cep_final: '', municipio_id: '', status: '', muncep_id: ''}),
   helpForm: new Form({statusRecord: [], params: []}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    ufSelected(obj) {
        this.form.uf_id = obj.value;
    }
},
mounted() {
    this.getLivGeral();
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.municipio_id);
        }
    },
    handleOkCep(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStoreCep();
        }
        else
        {
            this.onUpdateCep(this.form_cep.muncep_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onCreateCep (data)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form_cep.reset();
      this.form_cep.municipio_id = data.municipio_id;
      this.$refs.modal_form_cep.show();
    },
    onEditCep (data)
    {console.log(data);
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form_cep.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.form_cep.municipio_id = data.municipio_id;
      this.form_cep.cep_inicial = data.cep_inicial;
      this.form_cep.cep_final = data.cep_final;
      this.form_cep.muncep_id = data.muncep_id;
      this.form.status = data.status.valor;
      this.$refs.modal_form_cep.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.form.municipio_id = id;
      this.form.nome = data.nome;
      this.form.cd_ibge = data.cd_ibge;
      this.form.cd_opentech = data.cd_opentech;
      this.ufSelected = {label: data.uf.nome, value: data.uf.uf_id};
      this.form.status = data.status.valor;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/municipio/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onStoreCep()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form_cep.put('/api/municipio/cep/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/municipio/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdateCep(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form_cep.patch('/api/municipio/cep/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },

    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    getLivGeral()
    {
        this.helpForm.get('/api/municipio/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
            response.status_cep.forEach((obj)=>
            {
                this.optionsLivStatusCep.push({ text: obj.descr, value: obj.valor })
            })
            response.uf.forEach((obj)=>
            {
                this.optionsListItemUf.push({ label: obj.nome, value: obj.uf_id })
            })

        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
